import * as React from 'react';
import { useHistory } from 'react-router-dom';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import styled from 'styled-components'
import { ChevronDown } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';

const Wrapper = styled(Box)`
  width: 100%;
  display: flex;
  font-family: 'Roboto';
`

const ProfileMenu = props => {
  const history = useHistory()
  const { isDark } = useTheme()
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const isString = (variable) => {
    return typeof variable === "string";
  }
  
  return (
    <Wrapper style={props.style}>
      <>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'left' }}>
        <Button
          onClick={handleClick}
          style={{
            color: isDark ? 'var(--text-color)' : '#4E4B59',
            textTransform: 'none',
            fontSize: '14px',
            fontWeight: 500,
            padding: '4px 8px',
            borderRadius: '4px',
            backgroundColor: 'transparent',
            boxShadow: 'none',
            gap: '8px',
          }}
          endIcon={<ChevronDown style={{width: '16px', height: '16px', strokeWidth: 2, color: isDark ? 'var(--text-secondary)' : '#9997A0'}} />}
          startIcon={
            <div style={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              backgroundColor: isDark ? 'var(--table-row-zebra)' : '#F5F5F5',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: isDark ? 'var(--text-color)' : '#4E4B59',
              fontSize: '14px',
              fontWeight: 500
            }}>
              {props?.title && isString(props?.title) ? props?.title?.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase() : 'U'}
            </div>
          }
        >
          {props.title}
        </Button>
      </Box>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            boxShadow: isDark ? '0px 4px 6px -1px rgba(0, 0, 0, 0.3), 0px 2px 4px -1px rgba(0, 0, 0, 0.2)' : '0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)',
            mt: 0.5,
            borderRadius: '8px',
            border: isDark ? '1px solid var(--border-color)' : '1px solid #E0E0E0',
            backgroundColor: isDark ? 'var(--card-bg)' : '#FFFFFF',
            minWidth: '192px',
            '& .MuiMenuItem-root': {
                paddingLeft: '16px',
                paddingRight: '16px',
                fontSize: '14px',
                minHeight: '36px',
                color: isDark ? 'var(--text-color)' : undefined,
            },
            '& .MuiMenuItem-root:hover': {
                bgcolor: isDark ? 'var(--table-row-zebra)' : '#F5F5F5',
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {props.menuItems.map((item, index) => {
          return (
            <MenuItem
              key={index}
              onClick={() => history.push(item.path)}
            >
              {item.text}
            </MenuItem>
          )
        })}
      </Menu>
      </>
    </Wrapper>
  )
}

export default ProfileMenu

